import withInputFields from "../../helpers/inputfields";
import withReactiveFields from "../../helpers/reactivefields";
import { selectBankFromList } from "../../../../collections/nigerianbanks";
import { getValueAtPath, toArray, withProperties } from "../../../../utils";
import { USES_CHARGE_POLLING, USES_VALIDATE_POLLING } from "../../../../charge/flags";
import getChargeLimit from "../../../../lookup/limit";
import getChargeFee from "../../../../lookup/fee";
import ErrorState from "../../../common/error";
import { fetchSouthAfricanBanks, selectSouthAfricanBank } from "../../../../collections/southafricanbanks";

import InitView from "./views/init";
import ValidateView from "./views/otp";
import RedirectView from "../../common/redirect";
import ConfirmingView from "../../common/confirming";
import SuccessView from "../../common/success";

const METHOD = 'account';
const METHOD_NAME = 'Bank';
const CHARGE_MODE = USES_CHARGE_POLLING | USES_VALIDATE_POLLING;

const VIEWS = [ InitView, ValidateView ];

function mount() {
  return (dispatch) => {
    // Some logic here to determine the view to show instead of
    // always showing the form (first) view, nd also other stuffs
    // like fee check, limit check, etc.
    getChargeLimit.call(this, () => {
      const currency = getValueAtPath(this.STATE, 'currency.current')
      const VIEW = (
        this.REDIRECT_URL && (RedirectView || (this.REDIRECT_URL = null))
      ) || InitView;
      
      VIEW && VIEW.activate(() => {
        VIEW === InitView && currency === 'ZAR' && fetchSouthAfricanBanks(this).then(() => {
          this.$inputs.$reset('sa_bank');
          this.SA_BANKS = getValueAtPath(this, 'DATA.sa_banks.banks');
        })
      });
    });
    
    getChargeFee();
  };
}

function getChargeData() {
  if (this.SHOULD_VALIDATE_CHARGE) return;
  return ({ 
    payment_type: 'account',
  });
}

function getViewsContext(data, store) {
  let resendTimer;

  const currency = getValueAtPath(data, 'currency') || 'NGN';
  const isHighRisk = getValueAtPath(data, 'isHighRisk') === true;
  const ACCOUNT_BANKS = getValueAtPath(data, 'banks.account') || [];

  const REACTIVE_FIELDS = [
    'CAN_RESEND_OTP',
    'REDIRECT_URL',
    'VALIDATE_INSTRUCTION',
    'SHOULD_VALIDATE_CHARGE',
    'SA_BANKS',
    'IS_HIGH_RISK'
  ];

  const $context = withReactiveFields(Object.create(null), ...REACTIVE_FIELDS);

  $context.IS_HIGH_RISK = isHighRisk;

  $context.pollConfig = {
    onCancel() { $context.pollConfig.onComplete() },
    onSuccessful() { SuccessView && SuccessView.activate.call($context) },
    onComplete() { /* self.console.log({ ...$context }) */ }
  }

  $context.$subscribe('SA_BANKS', (currentValue, oldValue) => {
    setTimeout(() => {
      if (currentValue !== oldValue) {
        $context.$inputs.$refresh('sa_bank');
        $context.$inputs.$reset('sa_bank');
      }
    }, 0);
  });

  withInputFields($context, {
    otp: null,
    account_bvn: __availability__(['033']),
    account_dob: __availability__(['033', '057']),
    account_number: __availability__(['044', '050', '033', '232', '057', '215', '101']),
    account_otp: __availability__(['232']),
    account_phone: __availability__(['050', '232', '215'], getValueAtPath(data, 'phone') || null),
    // address: __availabilityGBP__(),
    bank: {
      options: ACCOUNT_BANKS,
      selector: selectBankFromList.bind($context, ACCOUNT_BANKS),
      available() { return currency === 'NGN' }
    },
    sa_bank: {
      get options() { return $context.SA_BANKS },
      get selector() { return selectSouthAfricanBank.bind($context, this.options) },
      available() { return currency === 'ZAR' }
    },
    customer_identifier: {
      available() { return currency === 'ZAR' && isHighRisk }
    },

    country:{
      available() { return currency === 'EUR' || currency === 'GBP'  }
    },
    // city: __availabilityGBP__(),
    // postal_code: __availabilityGBP__(),
    // state: __availabilityGBP__()
  });

  $context._subscribeInputsOnce = (() => {
    let subscribed = false;

    return () => {
      if (subscribed !== true && (subscribed = true)) {
        $context.$inputs.$subscribe('bank', (currentValue, oldValue) => {
          if (currentValue !== oldValue) {
            // Reset previous error message when the user switches bank
            $context.dispatch(ErrorState.actions.updateErrorMessage());
          }
        });
      }
    };
  })();

  $context.$subscribe('REDIRECT_URL', (currentValue, oldValue) => {
    setTimeout(() => {
      if (!(oldValue && oldValue === currentValue) && currentValue instanceof URL) {
        RedirectView && RedirectView.activate.call($context);
      }
    }, 0);
  });

  $context.$subscribe('SHOULD_VALIDATE_CHARGE', (currentValue, oldValue) => {
    setTimeout(() => {
      if (!(oldValue || oldValue === currentValue) && currentValue === true) {
        ValidateView && ValidateView.activate();
        $context.clearResendTimer();
        resendTimer = setTimeout(() => ($context.CAN_RESEND_OTP = true), 90 * 1000);
      }
    }, 0);
  });

  $context.cancelOption = () => {
    $context.$resetContext();
    InitView.activate.call($context);
  }

  return withProperties($context, {
    $resetContext() {
      $context.$inputs.$reset('sa_bank');
      $context.$inputs.$reset('bank');
      $context.REDIRECT_URL = $context.SHOULD_VALIDATE_CHARGE = null;
    },

    INIT_VIEW: callback => {
      const responseCode = getValueAtPath($context, '$$data.data.response_code');
      const hasError = !!getValueAtPath($context, '$$data.data.$error') === true || getValueAtPath($context, '$$data.status') === 'failed';

      if (!["00", "02"].includes(responseCode)) {
        $context.$resetContext();
        InitView && InitView.activate(callback);
      } else if (responseCode === "02" && !hasError) {
        setTimeout(() => {
          ConfirmingView && ConfirmingView.activate(() => {
            $context.$charge.poll({
              onCancel() { this.onComplete() },
              onSuccessful() { SuccessView && SuccessView.activate.call($context) },
              onComplete() { /* self.console.log({ ...$context }) */ }
            });
          });
        }, 0)
      }
    },

    clearResendTimer: () => {
      resendTimer && clearTimeout(resendTimer);
      resendTimer = null;
      $context.CAN_RESEND_OTP = false;
    }
  });

  function __availability__(banks, defaultValue = null) {
    if (!(banks instanceof Array)) {
      if (arguments.length === 1) { [banks, defaultValue] = [[], banks] }
      else if (defaultValue instanceof Array) { [banks, defaultValue] = [defaultValue, banks] }
      else { banks = [] }
    }

    banks = toArray(banks);
    defaultValue = defaultValue || null;

    return {
      defaultValue,
      available() {
        const bank = getValueAtPath($context.$inputs, '[bank].value.code') || null;
        return currency === 'NGN' && banks.indexOf(bank) >= 0;
      }
    }
  }

  function __availabilityGBP__(defaultValue = null) {
    return {
      defaultValue: defaultValue || null,
      available() { return currency === 'EUR' || currency === 'GBP' }
    }
  }
}

export {
  METHOD,
  METHOD_NAME,
  CHARGE_MODE,
  VIEWS,
  mount,
  getChargeData,
  getViewsContext
}
